import {LoadingCenter} from "@bounce/shared/ui";
import {useRedirectNoActivePlan} from "~/hooks/useRedirectNoActivePlan";
import {PropsWithChildren} from "react";
import {useAuth} from "@bounce/shared/contexts";
import {useConsumerUser} from "~/contexts";
import {useUiSettings} from "~/hooks";

const UiGuard = ({children}: PropsWithChildren) => {
  const {partnerDomain, isAnonymous} = useAuth();
  const {isLoading} = useUiSettings();
  const {userContext} = useConsumerUser();
  const isRedirectingToHappyMoney = useRedirectNoActivePlan(
    isAnonymous && partnerDomain === "happy_money",
    userContext
  );

  if (isLoading || isRedirectingToHappyMoney) {
    return <LoadingCenter />;
  }

  return <>{children}</>;
};

export default UiGuard;
